import Banner from './EuComps/Banner';
import PageNav from './EuComps/PageNav';
import NextGen from './EuComps/NextGen';
import Info from './EuComps/Info';
import NonstopPower from './EuComps/NonstopPower';
import M from './EuComps/M';
import PowerAnytime from './EuComps/PowerAnytime';
import PowerARange from './EuComps/PowerARange';
import ReliableUPS from './EuComps/ReliableUPS';
import TraditionalUPS from './EuComps/TraditionalUPS';
import ManagementSoftware from './EuComps/ManagementSoftware';
import MoreSmart from './EuComps/MoreSmart';
import WhyChoose from './EuComps/WhyChoose';
import FaqA from './EuComps/FaqA';
import FooterTcA from './EuComps/FooterTcA';

import css from './NewProductContent.module.scss';

export default function R3Page() {
    return (
        <div className={css.R3Page}>
            <Banner />
            <PageNav />
            <NextGen />
            <Info />
            <NonstopPower />
            <M />
            <PowerAnytime />
            <PowerARange />
            <ReliableUPS />
            <TraditionalUPS />
            <ManagementSoftware />
            <MoreSmart />
            <WhyChoose />
            <FaqA />
            <FooterTcA />
        </div>
    );
}
